<div class="d-flex flex-column w-100 gap-8">
    <div class="d-flex flex-row-reverse flex-wrap align-items-center justify-content-start gap-4">
        <ng-content select="[toolbar-section]"></ng-content>
    </div>

    <div class="main-container d-flex flex-column gap-6">
        <div class="row">
            <div class="col-lg-8 col-12 my-3" *ngIf="effectiveFilterConfigs && effectiveFilterConfigs.length">
                <app-search-v2 class=" w-full" (search)="search($event)" [searchValue]="currentSearch"></app-search-v2>
            </div>
            <div class="col-lg-12 my-3" *ngIf="!effectiveFilterConfigs || !effectiveFilterConfigs.length">
                <app-search-v2 class=" w-full" (search)="search($event)" [searchValue]="currentSearch"></app-search-v2>
            </div>
            <div class="col-lg-4 col-12 my-3">
                <app-filter-v2 class="w-full" [filterConfigs]="effectiveFilterConfigs"
                    [initialAppliedFilters]="appliedFilters"
                    (appliedFilters)="updateFilters($event)"
                    *ngIf="effectiveFilterConfigs && effectiveFilterConfigs.length"></app-filter-v2>
            </div>
        </div>

        <div class="loading-container">
            <app-loading-bar *ngIf="loading"></app-loading-bar>
        </div>
        <div class="table-responsive">
            <app-table-v1 [tableHeader]="tableHeader" [currentOrderBy]="currentOrderBy" (onSort)="onSort($event)"
                (onSelectAll)="onSelectAll.emit($event)" [selectStates]="selectStates">
                <ng-container table-rows>
                    <ng-content select="[table-rows]"></ng-content>
                </ng-container>
            </app-table-v1>
        </div>
        <div class="my-2"></div>
        <app-pagination-v1 [currentPage]="currentPage" [pageSize]="pageSize" [pageSizes]="pageSizes"
            [totalRecords]="totalRecords" (loadData)="loadingPage($event)"></app-pagination-v1>

    </div>
</div>